export const bindPrototypeMethodsToSelf = (
  instance: any,
  classFn?: Function,
) => {
  const prototype = classFn
    ? classFn.prototype
    : Object.getPrototypeOf(instance);

  const props = Object.getOwnPropertyNames(prototype);

  for (const prop of props) {
    if (prop === 'constructor' || typeof prototype[prop] !== 'function') {
      continue;
    }

    instance[prop] = prototype[prop].bind(instance);
  }
};
